export default __webpack_public_path__ + "b54c5d36f0398dd7341b58b4886a0ec5.png";